var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: [_vm.$mq.phone ? "bg-white" : "bg-gray"] },
    [
      _c("section", { staticClass: "container px-1 py-2 p-lg-3" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0"
            },
            [
              _c(
                "div",
                {
                  class: { "card shadow-sm": !_vm.$mq.phone },
                  attrs: { id: "start-booking-form" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "my-4",
                      class: { "card-body": !_vm.$mq.phone }
                    },
                    [
                      _c("section", { staticClass: "section-booking" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "h3",
                              { staticClass: "booking-title text-center" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.menu.search_professionals"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.scroll_down_see_detail"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 mt-4" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.choose_a_service"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-jumbo mb-3" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.parentServiceId,
                                        expression: "parentServiceId"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.parentServiceId = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                        _vm.setParentService
                                      ]
                                    }
                                  },
                                  _vm._l(_vm.availableServices, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm._f("multiLangName")(
                                                _vm.getService(item.id)
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 mt-4" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("h4", { staticClass: "pb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.booking_step.my_place"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm.user && _vm.state.userPlaces
                                ? _c(
                                    "div",
                                    { staticClass: "select-jumbo mb-3" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedUserPlaceId,
                                              expression: "selectedUserPlaceId"
                                            }
                                          ],
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.selectedUserPlaceId = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                              _vm.syncUserPlaceData
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.booking.booking_step.please_select"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.filteredUserPlaces,
                                            function(userPlace) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: userPlace.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        userPlace.place_name
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-jumbo" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedProvinceId,
                                        expression: "selectedProvinceId"
                                      }
                                    ],
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.selectedProvinceId = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                        _vm.setProvinceId
                                      ]
                                    }
                                  },
                                  _vm._l(_vm.sortedCities, function(
                                    city,
                                    index
                                  ) {
                                    return _vm.sortedCities[index].id > 0
                                      ? _c(
                                          "option",
                                          {
                                            domProps: {
                                              value: _vm.sortedCities[index].id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                         " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(city)
                                                ) +
                                                " \n                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  0
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.parentServiceId === 1
                            ? _c("div", { staticClass: "col-md-12 mt-4" }, [
                                _c("div", { staticClass: "form-group mb-2" }, [
                                  _c("h4", { staticClass: "pb-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.booking_step.accommodation"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "select-jumbo" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedPlaceSize,
                                            expression: "selectedPlaceSize"
                                          }
                                        ],
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedPlaceSize = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.setWorkHour
                                          ]
                                        }
                                      },
                                      _vm._l(_vm.sortedPlaceSizes, function(
                                        placeSize,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            domProps: {
                                              value:
                                                _vm.sortedPlaceSizes[index].id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(
                                                    placeSize
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "text-primary pl-1" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.booking_step.recommend"
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.globalState.durations[
                                              _vm.selectedPlaceSize
                                            ]
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "select-jumbo mt-2" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedWorkHour,
                                            expression: "selectedWorkHour"
                                          }
                                        ],
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.selectedWorkHour = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          }
                                        }
                                      },
                                      _vm._l(
                                        _vm.globalState.workHours,
                                        function(workHour, index) {
                                          return _c(
                                            "option",
                                            { domProps: { value: index } },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.$t(workHour)) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mt-2 pl-1 text-orange" },
                                  [
                                    _vm._v(
                                      "\n                    * " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.new_booking.excluding_break_time"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            : _vm.hasServiceItems
                            ? _c("div", { staticClass: "col-md-12 mt-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-start align-items-center"
                                  },
                                  [
                                    _c("div", { staticClass: "flex-fill" }, [
                                      _c("h4", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.service_item.select"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.serviceItems
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-info",
                                              attrs: { href: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.clearSelectedServiceItems()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.service_item.clear"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card pointer-item mb-1",
                                    class: [
                                      _vm.errorServiceItems
                                        ? "border-danger"
                                        : "border-divider"
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.openServiceItemModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      !_vm.serviceItems
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start align-items-center"
                                            },
                                            [
                                              _c("div", [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      _vm.parentService
                                                        .icon_url,
                                                    width: "24"
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex-fill px-3"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.service_item.select"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._m(0)
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start align-items-top"
                                            },
                                            [
                                              _c("div", [
                                                _c("img", {
                                                  staticClass:
                                                    "active-svg-icon",
                                                  attrs: {
                                                    src:
                                                      _vm.parentService
                                                        .icon_url,
                                                    width: "32"
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex-fill px-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.service_item.selected_list"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.serviceItems,
                                                    function(serviceItem) {
                                                      return _c("div", [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "multiLangName"
                                                              )(serviceItem)
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              serviceItem.count
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "multiLangName"
                                                              )(
                                                                serviceItem.item_unit
                                                              )
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ])
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-info text-small mt-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.service_item.remark"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-outline-info rounded-pill"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.button.edit"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errorServiceItems
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-alert-text -status-alert"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.required_selection")
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _c("div", { staticClass: "col-md-12 mt-4" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm.parentService &&
                                  _vm.parentService.child_services_text
                                    ? _c("h4", { staticClass: "pb-2" }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$i18n.locale === "th"
                                                ? _vm.parentService
                                                    .child_services_text
                                                    .title_th
                                                : _vm.parentService
                                                    .child_services_text
                                                    .title_en
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "select-jumbo" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedServiceId,
                                            expression: "selectedServiceId"
                                          }
                                        ],
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedServiceId = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.updateServiceData
                                          ]
                                        }
                                      },
                                      _vm._l(_vm.childServices, function(
                                        service,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            domProps: {
                                              value: _vm.childServices[index].id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(
                                                    service
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                ])
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", { staticClass: "pb-2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.pick_a_date"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 pr-2" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "pikadayBooking",
                                    rawName: "v-pikadayBooking",
                                    value: _vm.calendarData,
                                    expression: "calendarData"
                                  }
                                ],
                                ref: "cleaningDate",
                                staticClass:
                                  "form-control -date-picker input-jumbo",
                                class: { "form-alert": _vm.errorServiceDate },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$i18n.t(
                                    "message.booking.booking_step.date"
                                  ),
                                  readonly: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass:
                                  "far fa-calendar-alt input-text-icon"
                              })
                            ]),
                            _vm._v(" "),
                            _vm.errorServiceDate
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.date_is_required"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 pl-2" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "select-jumbo",
                                  class: { "form-alert": _vm.errorServiceTime }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedTime,
                                          expression: "selectedTime"
                                        }
                                      ],
                                      staticStyle: { background: "white" },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.selectedTime = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.new_booking.time"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.filteredTimes, function(time) {
                                        return _c(
                                          "option",
                                          { domProps: { value: time } },
                                          [_vm._v(_vm._s(time))]
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "far fa-clock input-text-icon"
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.errorServiceTime
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.required_selection")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "pl-1" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.booking_step.booking_today_remark"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://line.me/R/ti/p/@BeNeat",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      Line: @BeNeat\n                    "
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.my_reservations.or")) +
                                  "\n                    "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://www.facebook.com/beneatco/inbox/",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      Facebook Messenger\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-start align-items-center"
                              },
                              [
                                _c("div", { staticClass: "flex-fill" }, [
                                  _c("label", { staticClass: "text-dark" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.new_booking.subtotal"
                                          )
                                        ) +
                                        "\n                      "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-fill text-right" },
                                  [
                                    _c("h3", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("currency")(_vm.totalPrice)
                                          ) +
                                          "\n                      "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 text-center mt-4" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button button-large button-block -cyan",
                                  on: { click: _vm.goToChooseCleanerStep }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.booking_step.find_a_cleaner"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.state.currentStep === 1
        ? _c(
            "div",
            [
              _vm.$mq.phone
                ? _c("hr", { staticClass: "mx-3 mt-0 mb-4" })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedServiceId === 1
                ? _c("booking-detail")
                : _vm.selectedServiceId != 1 &&
                  _vm.parentService &&
                  _vm.parentService.detail_th
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0"
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$i18n.locale === "th"
                                    ? _vm.parentService.detail_th
                                    : _vm.parentService.detail_en
                                )
                              }
                            })
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasServiceItems
        ? _c("service-item-modal", {
            ref: "serviceItemModal",
            attrs: { parentService: _vm.parentService },
            on: { selectServiceItems: _vm.setServiceItems }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-plus-circle text-info fa-lg" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0875ccbb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0875ccbb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/steps/Booking.vue
// module id = 1759
// module chunks = 0